import { useRef } from 'react';

import { createUID } from '../utils';

/**
 * Generate unique identifier that is stable across renders.
 * @example const stableUID = useUID();
 * @returns uid:: The same autogenerated UID between renders.
 */
const useUID = (): string => {
  return useRef<string>(createUID()).current;
};

export default useUID;
